export enum ShiftPostStep {
  SHIFT_DETAILS = 'SHIFT_DETAILS',
  ACCEPTANCE_CRITERIA = 'ACCEPTANCE_CRITERIA',
  SCREENING_REQUIREMENTS = 'SCREENING_REQUIREMENTS',
  INVITE_UPSHIFTERS = 'INVITE_UPSHIFTERS',
  CONFIRM = 'CONFIRM',
}
